import { FC } from "react";

import { Stack } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { LiveEditorBlock } from "@/components/LiveEditorElements/LiveEditorBlock/LiveEditorBlock";
import { DashboardSwitch } from "@/dashboard-design-system/Switch";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface TeamActivityNotificationsCardProps {
  enabled: boolean;
  onEnabledChange: (next: boolean) => void;
}

export const TeamActivityNotificationsCard: FC<TeamActivityNotificationsCardProps> = ({ enabled, onEnabledChange }) => {
  const { t } = useTranslate();

  return (
    <LiveEditorBlock>
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <DashboardSwitch
          checked={enabled}
          onChange={(_, checked) => onEnabledChange(checked)}
          data-test="live-form-editor-team-activity-notifications-toggle"
        />
        <Stack gap={0.5}>
          <DashboardTypography variant="subtitle1" vibe="text-neutral-moderate">
            {t("dashboard", "ticketing.setThankYouEmail.teamActivityNotificationsLabel")}
          </DashboardTypography>
          <DashboardTypography variant="body2" vibe="text-neutral-quiet">
            {t("dashboard", "ticketing.setThankYouEmail.teamActivityNotificationsDescription")}
          </DashboardTypography>
        </Stack>
      </Stack>
    </LiveEditorBlock>
  );
};
